import { useEffect } from 'react';

const NOTIFY_TEXT_ELEMENT_ID = 'INDblindNotif';

export const useHideAccessabilityNotifyText = () => {
  useEffect(() => {
    const loadHandler = () => {
      const elem = document.getElementById(NOTIFY_TEXT_ELEMENT_ID);

      if (!elem) return;

      elem.setAttribute('aria-hidden', 'true');
      elem.style.display = 'none';
    };

    document.addEventListener('DOMContentLoaded', loadHandler, false);
    window.addEventListener('load', loadHandler, false);

    return () => {
      document.removeEventListener('DOMContentLoaded', loadHandler, false);
      window.removeEventListener('load', loadHandler, false);
    };
  }, []);

  return null;
};
